import { render, staticRenderFns } from "./directorCard.vue?vue&type=template&id=f3a29564&scoped=true&"
import script from "./directorCard.vue?vue&type=script&lang=js&"
export * from "./directorCard.vue?vue&type=script&lang=js&"
import style0 from "./directorCard.vue?vue&type=style&index=0&id=f3a29564&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a29564",
  null
  
)

export default component.exports